import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { ViewStatFields } from '../../ts/models/ContentTypes';
import { IRecentContentInfo } from '../../ts/models/IRecentContentInfo';
import { GetDetailedRecentsRequest } from '../../ts/ServerApi/requests/GetDetailedRecentsRequest';
import { ILeafFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';

class RecentsResource {

  private getRecentViews: IListFetcher<IRecentContentInfo> = new WebClientListResourceFetcher(
    GetDetailedRecentsRequest, ServerApiMapper.recentItems);

  public all(contentTypes: ReadonlyArray<ExplorableItemType>, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IRecentContentInfo> {
    let objectTypes: string[] = contentTypes.map((contentType) => {
      if (contentType === 'view') {
        return 'VIEW';
      } else if (contentType === 'metric') {
        return 'METRIC';
      }
      return '';
    }).filter((value => value.length > 0));

    if (objectTypes.length === 0) {
      objectTypes = ['VIEW'];
    }

    return new ResourceQuery(this.getRecentViews)
      .withExtraParams({'viewStatFields': ViewStatFields, 'objectTypes': objectTypes})
      .withFilters(additionalFilterClauses);
  }
}

export const Recents = new RecentsResource();
